import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'subscriber-advertiser-datatable',
  standalone: false,
  templateUrl: './subscriber-advertiser-datatable.component.html',
  styleUrl: './subscriber-advertiser-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdvertiserDatatableComponent extends BaseComponent {
  protected _router = inject(Router);

  subscribers = input([]);

  displayedColumns: string[] = [
    'advertiser',
    'nbrAdvertiser',
    'dominantMediatype',
    'actions'
  ];
}
